// CSS Dependencies
import './assets/css/colors.css'
import './assets/css/animations.css'
import './assets/css/reset.css'
import './assets/css/global.css'
import './assets/css/form.css'

// Dependencies
import Vue from 'vue'

// Components/Modules
import { VueRouter, router } from './router'

// Vuex Store
import store from './vuex/store'

// Load config
Vue.config.kQuotes = process.env

// Router
Vue.use(VueRouter)

/* eslint-disable no-new */
new Vue({
  router,
  store,
  el: Vue.config.kQuotes.ROOT_ELEM,
  template: '<router-view></router-view>'
})



// WEBPACK FOOTER //
// ./src/main.js